<template>
  <div class="p-4 sm:p-6 lg:p-10 max-w-7xl mx-auto">
    <PageHeader title="Zgody marketingowe" subtitle="Zarządzaj zgodami na komunikację marketingową" />

    <div class="bg-white border border-neutral-100 rounded-lg-custom p-6">


      <div class="flex items-center justify-between gap-6">

        <ToggleSwitch :modelValue="emailMarketingConsent" :disabled="saving || !loaded"
          @update:modelValue="setEmailMarketingConsent" />
        <div>
          <div class="text-sm font-semibold text-neutral-850">Zgoda na działania marketingowe jest kluczowym
            elementem współpracy z naszymi klientami. Przykładowo, możemy informować Cię o nowych produktach, promocjach
            oraz wydarzeniach, które mogą Cię zainteresować.</div>
          <div class="text-xs text-neutral-600 mt-1">
            Odznacz, jeśli nie chcesz otrzymywać ofert i informacji marketingowych.
          </div>
        </div>


      </div>


    </div>


    <FormSection title="Zgody uczestników kursów" class="mt-6 space-y-6">

      <div class="flex items-center justify-start gap-6">

        <ToggleSwitch v-model="formData.consent1" :disabled="true" />
        <div>
          <div class="text-sm font-semibold text-neutral-850">Zgoda RODO na przetwarzanie danych osobowych.
          </div>
          <div class="text-xs text-neutral-600 mt-1">
            Ta zgoda jest niezbędna do udziału w kursach, ponieważ umożliwia nam przetwarzanie Twoich danych osobowych
            zgodnie z obowiązującymi przepisami RODO.
          </div>
        </div>


      </div>


      <div class="flex items-center justify-start gap-6">

        <ToggleSwitch v-model="formData.consent1" :disabled="true" />
        <div>
          <div class="text-sm font-semibold text-neutral-850">Zgoda RODO na przetwarzanie danych osobowych.
          </div>
          <div class="text-xs text-neutral-600 mt-1">
            Ta zgoda jest niezbędna do udziału w kursach, ponieważ umożliwia nam przetwarzanie Twoich danych osobowych
            zgodnie z obowiązującymi przepisami RODO.
          </div>
        </div>


      </div>

      <div class="flex items-center justify-start gap-6">

        <ToggleSwitch v-model="formData.consent1" :disabled="true"   />
        <div>
          <div class="text-sm font-semibold text-neutral-850">Zgoda RODO na przetwarzanie danych osobowych.
          </div>
          <div class="text-xs text-neutral-600 mt-1">
            Ta zgoda jest niezbędna do udziału w kursach, ponieważ umożliwia nam przetwarzanie Twoich danych osobowych
            zgodnie z obowiązującymi przepisami RODO.
          </div>
        </div>


      </div>

    

    </FormSection>

  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue';
import ToggleSwitch from '../../components/ToggleSwitch.vue';
import FormSection from '../../components/FormSection.vue';
import rpAPI from '@shared/service/rpAPI.js';

export default {
  name: 'CustomerUnsubscribe',
  components: {
    PageHeader,
    ToggleSwitch,
    FormSection
  },
  data() {
    return {
      loaded: false,
      saving: false,
      emailMarketingConsent: false,
      formData: {
        consent1: true,
        consent2: true,
        consent3: true,
      },
    };
  },
  async mounted() {
    try {
      await rpAPI.ensureUser();
      this.emailMarketingConsent = rpAPI.user?.email_notifications === true;
      this.loaded = true;
    } catch (error) {
      this.loaded = true;
      this.$notify?.error?.('Nie udało się wczytać ustawień powiadomień.');
    }
  },
  methods: {
    async setEmailMarketingConsent(nextValue) {
      const previousValue = this.emailMarketingConsent;
      this.emailMarketingConsent = Boolean(nextValue);

      this.saving = true;
      try {
        await rpAPI.updateCustomer({
          email_notifications: this.emailMarketingConsent,
        });

        this.emailMarketingConsent = rpAPI.user?.email_notifications === true;
        this.$notify?.success?.('Zapisano ustawienia powiadomień.');
      } catch (error) {
        this.emailMarketingConsent = previousValue;
        this.$notify?.error?.(error?.message || 'Nie udało się zapisać ustawień.');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
